import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import { IAddress, ICurrency, IRate } from "@/modules/sell/types";
import IIndexable from "@/utils/types/IIndexable";
import { Component, Inject, Mixins, Prop, Ref } from "vue-property-decorator";
import VEmptyState from "@/vuetify-extensions/VEmptyState.vue";
import NetworkErrorImage from "@/components/NetworkErrorImage.vue";
import { EServices } from "@/types";
import RatesClient from "../../services/RatesClient";
import CryptoMicroservicesClient from "../../services/CurrenciesClient";
import { namespace } from "vuex-class";
import { IAccount } from "@/modules/auth/types";
import qrcode from "qrcode-generator";

const AccountModule = namespace("AccountModule");

@Component({
  components: {
    VEmptyState,
    NetworkErrorImage,
  },
})
export default class SellDetails extends Mixins(JackocoinsNetworkManagerMixin) {
  @Prop({
    type: Number,
    required: true,
  })
  rateId!: number;

  loading: IIndexable<boolean> = {
    getRates: true,
    getUserCurrencyAddress: true,
  };

  tabIndex = 0;
  range = 0;
  rate: IRate | null = null;
  addressInfo: null | IAddress = null;
  qrCode = qrcode(4, "L");

  @AccountModule.State
  account!: IAccount;

  @Inject(EServices.rates)
  ratesClient!: RatesClient;

  @Inject(EServices.crypto)
  cryptoMicroservicesClient!: CryptoMicroservicesClient;

  @Ref()
  copyPasteInput!: HTMLInputElement;

  @throwsNetworkError()
  async getUserCurrencyAddress() {
    const address = await this.cryptoMicroservicesClient.getWalletAddress(
      this.currency.symbol,
      this.currency.chain
    );
    this.qrCode.addData(address);
    this.qrCode.make();
    this.addressInfo = {
      address,
      qrCode: this.qrCode.createSvgTag(5),
    } as IAddress;
  }

  get currencyName(): string {
    return this.rate!.currency.name;
  }

  get currency(): ICurrency {
    return this.rate!.currency;
  }

  copyAddress() {
    this.copyPasteInput.select();
    this.copyPasteInput.setSelectionRange(0, this.copyPasteInput.value.length);
    document.execCommand("copy");
    toast({
      icon: "mdi-check",
      message: "Address Copied!",
      iconColor: "green",
    });
  }

  @throwsNetworkError()
  async getRate() {
    this.rate = await this.ratesClient.getRate(this.rateId);
    if (this.rate.currency.name.startsWith("Bitcoin")) {
      this.rate.currency.name = "Bitcoin";
    }
  }

  mounted() {
    this.getRate().then(() => this.getUserCurrencyAddress());
  }
}
